import { Navigate, useParams } from "react-router-dom";

export default function RedirectLegacyTagsRoute() {
  const { siteId } = useParams();

  return <Navigate to={siteId ? `/app/publish/${siteId}` : "/app"} replace />;
}
